import { LocalDate } from '@js-joda/core';

import { Bean, convertDateToLocalDate, FormContextValues, ValidationRules } from '@dreryk/react-common';
import { DatePicker, isDateAfterNow, isDateBefore } from '@dreryk/react-components';

import { visitDetailsTranslationKeys } from '../../../../../../../translations';

const CHRONIC_DISEASE_REMOVAL_DATE_FIELD_NAME = 'chronicDiseaseRemovalDate';

export type ChronicDiseaseRemovalDateFormBeanPart = {
   [CHRONIC_DISEASE_REMOVAL_DATE_FIELD_NAME]: LocalDate;
};

type RemovalDatePickerProps = Pick<FormContextValues<ChronicDiseaseRemovalDateFormBeanPart>, 'register'> & {
   readonly visitBeginDate: Date;
};

export const RemovalDatePicker = (props: RemovalDatePickerProps): JSX.Element => {
   const VALIDATION_RULES: ValidationRules<Bean> = {
      required: true,
      validate: (selectedChronicDiseaseRemovalDate) => {
         if (selectedChronicDiseaseRemovalDate instanceof LocalDate) {
            if (isDateAfterNow(selectedChronicDiseaseRemovalDate)) {
               return visitDetailsTranslationKeys.diagnoses.removalChronicDisease.form.chronicDiseaseRemovalDate
                  .validate.cannotBeDateInFuture;
            }

            if (isDateBefore(selectedChronicDiseaseRemovalDate, convertDateToLocalDate(props.visitBeginDate))) {
               return visitDetailsTranslationKeys.diagnoses.removalChronicDisease.form.chronicDiseaseRemovalDate
                  .validate.cannotBeBeforeBeginVisitDate;
            }
         }

         return undefined;
      },
   };

   return (
      <DatePicker
         controller={props.register(CHRONIC_DISEASE_REMOVAL_DATE_FIELD_NAME, VALIDATION_RULES)}
         label={visitDetailsTranslationKeys.diagnoses.removalChronicDisease.form.chronicDiseaseRemovalDate.label}
         testId={'chronicDiseaseRemovalDate'}
         withNavigationArrows
      />
   );
};
